import blog1Url from '@/assets/images/blog-1.webp?url'
import blog2Url from '@/assets/images/blog-2.webp?url'
import blog3Url from '@/assets/images/blog-3.webp?url'

export type BlogCategory = 'insights' | 'practice' | 'cases'

export interface Article {
  /** Both the route slug and the i18n namespace (`blog.articles.<key>.*`) */
  key: string
  category: BlogCategory
  /** ISO date, for search engines */
  published: string
  /** Route an article ends on, with its text in `blog.articles.<key>.cta` */
  cta?: string
}

// Newest first. Each article's text lives in the i18n files: name, body
// (the teaser), tag, quote and sections s1…sN with a title and a body.
export const articles: Article[] = [
  { key: 'vibe-coding-for-companies', category: 'practice', published: '2026-10-24', cta: 'workbench' },
  { key: 'standard-software-everyday-costs', category: 'insights', published: '2026-10-09' },
  { key: 'build-vs-buy', category: 'insights', published: '2026-10-09' },
  { key: 'ai-native-not-ai-automatic', category: 'practice', published: '2026-10-09' },
  { key: 'discovery-sprint', category: 'practice', published: '2026-10-09' },
  { key: 'mvp-not-a-throwaway-prototype', category: 'practice', published: '2026-10-09' },
  { key: 'ai-agents-swiss-data-protection', category: 'cases', published: '2026-10-09' },
]

export const articleKeys = articles.map((a) => a.key)

export const articleByKey = (key: string): Article =>
  articles.find((a) => a.key === key) ?? articles[0]

const images = [blog1Url, blog2Url, blog3Url]

/** The card image, rotating through the blog images in list order */
export const articleImage = (key: string): string =>
  images[Math.max(0, articleKeys.indexOf(key)) % images.length]

/** Other articles, those in the same category first */
export const relatedArticles = (key: string, count: number): Article[] => {
  const category = articleByKey(key).category
  const others = articles.filter((a) => a.key !== key)
  return [
    ...others.filter((a) => a.category === category),
    ...others.filter((a) => a.category !== category),
  ].slice(0, count)
}
